import { NavLink, Outlet } from 'react-router-dom';
import { Users, User, ChevronLeft, Upload, Building2, SlidersHorizontal, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { isOrgAdmin } from '../utils/permissions';

const SECTIONS = [
  {
    label: 'Conta',
    items: [
      { to: '/settings/profile', label: 'Meu perfil', icon: User },
    ],
  },
  {
    label: 'Organização',
    adminOnly: true,
    items: [
      { to: '/settings/organization', label: 'Identidade visual', icon: Building2 },
    ],
  },
  {
    label: 'Diretório',
    adminOnly: true,
    items: [
      { to: '/settings/users', label: 'Usuários', icon: Users },
      { to: '/settings/roles', label: 'Grupos de permissão', icon: Shield },
    ],
  },
  {
    label: 'Importação',
    adminOnly: true,
    items: [
      { to: '/settings/import', label: 'Importar do Monday', icon: Upload },
    ],
  },
  {
    label: 'Personalização',
    adminOnly: true,
    items: [
      { to: '/settings/customize', label: 'Personalizar', icon: SlidersHorizontal },
    ],
  },
];

export default function SettingsLayout() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const isAdmin = isOrgAdmin(user);

  return (
    <div className="h-screen flex bg-main">
      <aside className="w-64 bg-sidebar border-r border-border flex flex-col">
        <div className="px-4 py-4 border-b border-border/50">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-sm text-text-secondary hover:text-text-primary transition-colors"
          >
            <ChevronLeft className="w-4 h-4" />
            Voltar
          </button>
          <h1 className="mt-3 text-lg font-semibold text-text-primary">Administração</h1>
        </div>
        <nav className="flex-1 overflow-y-auto py-2">
          {SECTIONS.filter((s) => !s.adminOnly || isAdmin).map((section) => (
            <div key={section.label} className="mb-4">
              <div className="px-4 py-1 text-[11px] uppercase tracking-wider text-text-secondary/70 font-semibold">
                {section.label}
              </div>
              {section.items.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-2 text-sm transition-colors ${
                      isActive
                        ? 'bg-accent/15 text-accent border-l-2 border-accent'
                        : 'text-text-primary hover:bg-white/5 border-l-2 border-transparent'
                    }`
                  }
                >
                  <item.icon className="w-4 h-4" />
                  {item.label}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
      </aside>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
